import { RolesValues } from '@constants';
import { TFunction } from 'i18next';

export const getRoleNameTranslation = ({ roleName, t }: { roleName?: RolesValues; t: TFunction }) => {
  return roleName ? t(`roles.${roleName}`) : t('roles.roleNotAssigned');
};
